import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Optional,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { Evaluator } from 'formiojs/utils/utils';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { FormioLoader, FormioCustomComponent, FormioComponent, STEPPERTABSTATUS, ResourceNameService, FormioTranslate } from 'dp-formio';

declare var $;

@Component({
	selector: 'app-table-view-wrapper',
	templateUrl: './table-view-wrapper.component.html',
	// styleUrls: ['./table-view-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class TableViewWrapperComponent
	implements FormioCustomComponent<any>, OnChanges, AfterViewInit, OnDestroy
{
	@ViewChild(FormioComponent) formComponent: FormioComponent;

	dir: 'rtl' | 'ltr';
	@Input() required: boolean;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Input() disabled: boolean;
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;

	submission: any = {};
	showColumns: any[] = [];
	resourceData = [];
	translationsObj: string;
	conditionalField: string;
	componentKey: string;
	isFOView: boolean;
	isBOView: boolean;
	exportColumns: any[];
	showLoader: boolean;
	openDialog: boolean;
	downloadPDF: boolean;

	public get TABSTATUS(): typeof STEPPERTABSTATUS {
		return STEPPERTABSTATUS;
	}

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(
		private formioLoader: FormioLoader,
		private resourceNameService: ResourceNameService,
		private translateService: TranslateService,
		@Optional() private translate: FormioTranslate
	) {
		this.changeDirection(this.translateService.currentLang);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes &&
			changes.data &&
			!_isEmpty(changes.data.currentValue) &&
			!_isEqual(changes.data.currentValue, changes.data.previousValue)
		) {
			if (this.customOptions) {
				this.customOptions.downloadPDF == true
					? (this.downloadPDF = true)
					: (this.downloadPDF = false);
				if (this.customOptions.showColumns && this.customOptions.showColumns.length) {
					this.isFOView = this.customOptions.isFOView;
					this.isBOView = this.customOptions.isBOView;

					this.conditionalField = this.customOptions.conditionalField;
					this.translationsObj = this.customOptions.translationsObj;

					this.showColumns = this.customOptions.showColumns;
					if (this.isFOView) {
						this.showColumns = this.customOptions.showFOColumns;
					} else if (this.isBOView) {
						this.showColumns = this.customOptions.showBOColumns;
					}

					this.submission.data = {
						...this.data,
					};

					if (this.data) {
						this.getResourceData();
					}
				}
			}
		}
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	private getResourceData() {
		this.formioLoader.loading = true;

		const query = this.customOptions.query
			? Evaluator.interpolate(this.customOptions.query, { data: this.data })
			: `${this.customOptions.queryField}${this.customOptions.queryOperator}${this.data.varRequestId}&limit=${this.customOptions.limit}&${this.customOptions.sortParam}`;

		this.sub = this.resourceNameService
			.loadCustomByFilterdKey(this.customOptions.resource, query)
			.pipe(
				tap((response: any[]) => {
					if (response && response.length) {
						const data: any[] = response.map((item: any) => {
							return item.data;
						});

						this.FilterFOColumns(data);

						this.resourceData = [...data];

						this.notifyValue();
					}
				}),
				finalize(() => {
					this.formioLoader.loading = false;
				}),
				catchError((error) => {
					this.formioLoader.loading = false;
					return of([0]);
				})
			)
			.subscribe();
	}

	FilterFOColumns(resourceData: any[]) {
		if (resourceData && resourceData.length && this.isFOView && this.conditionalField) {
			if (!resourceData[0][this.conditionalField]) {
				this.showColumns = this.customOptions.showCustomFOColumns;
			}
		}

		this.exportColumns = this.showColumns.map((col) => ({
			title: this.translate.instant(this.translationsObj + col.key),
			dataKey: col.key,
		}));
	}

	notifyValue() {
		this.value = {
			tableData: [...this.resourceData],
		};
		this.valueChange.emit(this.value);
	}

	// exportPDF2() {
	// 	const input = document.getElementById('summaryContainer');
	// 	html2canvas(input, { scale: 5 }).then((canvas) => {
	// 		const imgData = canvas.toDataURL('image/png', 1.0);
	// 		const pdf = new jsPDF('p', 'mm', 'a4');
	// 		pdf.setFontSize(30);
	// 		pdf.addImage(imgData, 'PNG', 45, 5, 120, 250);
	// 		pdf.save('download.pdf');
	// 		this.openDialog = false;
	// 		setTimeout(() => {
	// 			this.showLoader = true;
	// 		}, 1000);
	// 	});
	// }

	exportPDF() {
		var HTML_Width = $('.summaryContainerClass').width();
		var HTML_Height = $('.summaryContainerClass').height();
		var canvas_image_width = HTML_Width;
		var canvas_image_height = HTML_Height;
		var top_left_margin = 15;
		var PDF_Width = HTML_Width + top_left_margin * 5;
		var PDF_Height = PDF_Width * 1.6 + top_left_margin * 2;

		var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

		html2canvas($('.summaryContainerClass')[0], { allowTaint: true, useCORS: true, scale: 2 }).then(
			(canvas) => {
				canvas.getContext('2d');

				var imgData = canvas.toDataURL('image/jpeg', 1.0);
				var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
				pdf.setLineHeightFactor(3);
				pdf.addImage(
					imgData,
					'JPG',
					top_left_margin,
					top_left_margin,
					canvas_image_width,
					canvas_image_height
				);
				pdf.setLineHeightFactor(3);

				for (var i = 1; i <= totalPDFPages; i++) {
					pdf.addPage(PDF_Width, 'p');
					pdf.addImage(
						imgData,
						'JPG',
						top_left_margin,
						-(PDF_Height * i) + top_left_margin * 4,
						canvas_image_width,
						canvas_image_height
					);
					pdf.setLineHeightFactor(3);
				}

				pdf.save('Document.pdf');
				this.openDialog = false;
				setTimeout(() => {
					this.showLoader = false;
				}, 500);
			}
		);
	}

	showDialog() {
		this.openDialog = true;
		this.showLoader = true;
		setTimeout(() => {
			this.exportPDF();
		}, 1000);
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}
}
